export default function handleLinkClick(
  linkText: string,
  linkUrl: string,
  linkTag: string = 'link',
): void {
  const route = useRoute();
  const { $event } = useNuxtApp();

  if (route.fullPath === '/' || linkUrl === route.fullPath) {
    $event('closeMenu', true);

    if (import.meta.client) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    }
  }
  gtmTrackEvent({
    linkText,
    linkUrl,
    linkAnalyticsTag: linkTag,
  });
}
